import script from "./CodeAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeAccess.vue?vue&type=script&setup=true&lang=js"

import "./CodeAccess.vue?vue&type=style&index=0&id=c3382ad2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3382ad2"]])

export default __exports__